/// <amd-module name="Repos/Views/Settings/Repositories/Components/RepositoriesZeroData" />
import React = require("react");
import * as Resources from "Repos/Views/Settings/Repositories/Resources";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { ZeroData, ZeroDataActionType } from "VSSUI/ZeroData";

interface IRepositoriesZeroDataProps {
    hasCreateRepoPermissions: boolean;
    renderCreatePanel(): void;
}

export class RepositoriesZeroData extends VssComponent<IRepositoriesZeroDataProps> {
    public constructor(props: IRepositoriesZeroDataProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render = (): JSX.Element => {
        const {hasCreateRepoPermissions, renderCreatePanel} = this.props;
        return (
            <ZeroData
                className="flex-grow"
                imagePath={getAssetLocation(this.context.pageContext, "ms.vss-code-web/settings-repositories-content/Content/no-results.png")}
                imageAltText={Resources.ZeroReposSecondary}
                primaryText={Resources.ZeroReposPrimary}
                secondaryText={Resources.ZeroReposSecondary}
                actionText={hasCreateRepoPermissions ? Resources.Create : undefined}
                actionType={hasCreateRepoPermissions ? ZeroDataActionType.ctaButton : undefined}
                onActionClick={hasCreateRepoPermissions ? (event, item) => {
                    renderCreatePanel();
                } : undefined}
            />
        );
    };
}
